var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOutlook365(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "400px",
    height: "400px",
    viewBox: "0 0 400 400",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_305595240"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 400,
    height: 400
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0070C4",
    d: "M10 49l0 302c6,0 95,16 100,17 28,5 58,10 86,15 19,4 16,2 38,2l0 -82c14,0 127,0 132,0 8,-1 15,2 20,-6 1,-2 3,-7 3,-10 0,-20 1,-158 0,-167 -1,-4 3,-19 -18,-19l-136 0 0 -86 -23 0c-6,0 -8,1 -26,4l-168 29c-3,0 -4,1 -7,1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFF",
    d: "M235 178c-1,1 0,0 -1,1 0,0 0,1 0,2l0 109 142 0 0 -151c-3,2 -33,31 -39,36l-13 12c-4,4 -7,6 -13,12l-9 8c-2,1 -2,3 -4,4 -15,13 -15,12 -30,-1l-9 -8c-8,-7 -14,-14 -21,-20 -2,-1 -3,-3 -4,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFF",
    d: "M113 127c-51,7 -62,77 -41,114 2,3 5,8 6,9 2,2 2,2 4,4 3,3 10,7 15,9 41,19 81,-17 77,-72 -2,-27 -11,-50 -34,-61 -8,-4 -18,-5 -27,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFF",
    d: "M285 208l27 -25c5,-5 4,-4 9,-9l12 -11c3,-3 6,-5 9,-8l27 -26c4,-4 7,-8 8,-15 -18,0 -138,-1 -143,0l0 45c0,4 1,4 4,6l23 22c5,5 7,6 9,9 2,2 12,12 15,13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0070C4",
    d: "M110 154c-18,5 -25,27 -23,50 1,12 4,20 9,28 4,6 14,13 26,10 28,-8 27,-60 14,-78 -5,-6 -14,-13 -26,-9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#65A9DB",
    d: "M376 290l-142 0 0 -109c0,0 0,-1 0,-2 0,-2 0,0 1,-1l-1 -1c-1,9 -1,110 0,113 6,1 115,0 137,0 1,0 2,0 3,0 2,0 0,0 1,0l1 0z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOutlook365);
export default __webpack_public_path__ + "static/media/icon_outlook_365.227060ed8fac4f3168083f86fafd7049.svg";
export { ForwardRef as ReactComponent };